<template>
    <div class="header" :class="{'has-alert': showTrialAlert && !hiddenAlert}">
        <div v-if="mobileDevices"></div>
        <div v-else class="position-fixed w-100 fixed-header">
            <Alert v-if="showTrialAlert" :onHiddenChange="onHiddenChange"/>
            <div :class="{'no-box-shadow': isEcommercePlatform, 'inset-shadow': isEcommercePlatform}" 
            class="header-navbar d-flex align-items-center">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12" :class="{'px-0': showSearchBar, 'pl-3': user.trial && !user.subscription}">
                            <div data-name="search-bar" v-if="showSearchBar">
                                <SearchBar @hide="hide"/>
                            </div>
                            <div v-else class="cp-navbar d-flex align-items-center justify-content-between">
                                <div>
                                    <router-link id="cp-header-logo" :to="user ? '/browse': '/'">
                                        <Logo />
                                        <!-- <img class="d-lg-inline-block" style="margin-left: 8px;" v-lazy="'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2FCROSSPROM.png?alt=media&token=1b42efd0-4bd3-4067-9fdd-d769868f431c'" alt=""> -->
                                    </router-link>
                                </div>
                                <div class="action-bucket d-flex align-items-center justify-content-between">
                                    <div class="d-flex" v-if="!isEcommercePlatform">
                                        <a
                                            v-if="!isEcommercePlatform"
                                            class="position-relative navbar-item has-badge"
                                            href="https://ecommerce.crossprom.com/"
                                            target="_blank"
                                            @click="toEcommerce">
                                            E-commerce
                                            <span></span>
                                        </a>
                                        <a
                                            class="navbar-item"
                                            href="https://help.crossprom.com/"
                                            target="_blank"
                                            @click="toCrosspromHelp"
                                            id="help-header"
                                        >
                                            Help
                                        </a>
                                        <router-link 
                                            v-if="!dashboardHeader"
                                            class="hasPricing navbar-item"
                                            :class="{'hasPricing': !user.subscription}"
                                            to="/dashboard"
                                            @click.native="toDashboard"
                                            id="dashboard-header"
                                        >
                                            Dashboard
                                        </router-link>
                                        <router-link
                                            class="pricingLink navbar-item"
                                            to="/pricing"
                                            @click.native="toPricing"
                                        >
                                            Pricing
                                        </router-link>
                                    </div>
                                    <div 
                                        class="header-icons-wrap d-flex align-items-center"
                                        style="padding: 0 20px"
                                        :class="{'ecommerce': isEcommercePlatform }"
                                    >
                                        <button 
                                            v-b-tooltip.hover 
                                            class="p-0" 
                                            title="Search" 
                                            v-if="!isEcommercePlatform"
                                            id="search-icon-header" 
                                            @click="handleSearchIconClick"
                                        >
                                                <SearchIcon />
                                        </button>
                                        <router-link
                                            id="chatroom-header" 
                                            to="/mymessages"
                                            @click.native="toMessages"
                                            v-b-tooltip.hover 
                                            title="Messages" 
                                        >
                                            <Message/>
                                            <span 
                                                v-if="$store.state.unreadMessages"
                                                id="message-red-dot"
                                                class="unread_message"
                                            />
                                        </router-link>
                                        <notifications-dropdown v-if="!isEcommercePlatform"/>
                                    </div>
                                    <div class="add-campaign" style="padding: 0 20px">
                                        <a
                                            :href="addButtonLink"
                                            class="d-block "
                                            id="wizard-button-header"
                                            @click.prevent="openWizard">
                                                <button :class="{'inactive': $route.path === '/add-shop', 'add-camp-button': !isEcommercePlatform}" class="accept-button d-flex align-items-center">
                                                    <Icon icon="plus" width="14"/>
                                                    <span v-if="isEcommercePlatform">Add Shop</span>
                                                    <span v-else>Add Campaign</span>
                                                </button>
                                        </a>
                                    </div>
                                    <div class="position-relative">
                                        <UserDropdwon/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            

        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import UserDropdwon from "./UserDropdown"
import SearchBar from '../SearchBar'
import NotificationsDropdown from './NotificationsDropdown'
import Icon from '../Theme/Icon'
import Alert from '../Theme/Alert'
import {chatUseCase} from '../../core/usecases'

import {
    Logo,
    SearchIcon,
    Message,
    ProfPic
} from '../Icons'
export default {
    name: 'HeaderLogin',
    components: {
        Alert,
        UserDropdwon,
        NotificationsDropdown,
        Logo,
        SearchIcon,
        Message,
        ProfPic,
        SearchBar,
        Icon
    },
    data() {
        return {
            showSearchBar: false,
            showDropdown: false,
            mobileDevices: false,
            addButtonLink: '/wizard',
            hiddenAlert: false,
        }
    },
    watch: {
        '$route.path': 'hide'
    },
    mounted: function() {
        this.hide()
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
        })
        this.setAddButtonLink()
    },
    props: {
        dashboard: Boolean
    },
    computed: {
        ...mapState([
            'user'
        ]),
        ...mapGetters([ 
            'inPremium',
            'hasTrial', 
            'membershipStatus', 
            'trialTimeRemaining', 
            'isEcommercePlatform'
        ]),
        dashboardHeader: function() {
            return this.$route.path.includes('dashboard')
        },
        showTrialAlert(){
            return !this.isEcommercePlatform && !this.inPremium && !this.$route.path.includes('pricing')
        }

    },
    methods: {
        toEcommerce(){
            this.$sendMixpanelEvent('Ecommerce Link Clicked', {
                'Link Location': 'Navbar',
                'LoggedIn': true
            });

            this.$ga.event('Ecommerce Clicked', 'Click', `
                LoggedIn: true,
                Link Location: Navbar
            `)
        },
        getWindowWidth(event) {
            this.mobileDevices = document.documentElement.clientWidth < 768
        },
        toCrosspromHelp(){
            this.$ga.event('Help', 'Click', `
                LoggedIn: true,
                Location: Navbar
            `)
            this.$sendMixpanelEvent('Help Clicked', {
                'Logged In': true,
                'Link Location': 'Navbar'
            });
        },
        toPricing(){
            this.$sendMixpanelEvent('Pricing Page Opened', {
                'Opened From': 'Navbar Pricing Link',
                'Logged In': true
            });

            this.$ga.event('Pricing', 'Pricing Page Opened',`
                OpenedFrom:Navbar Pricing Link,
                LoggedIn:true
            `);
        },
        onHiddenChange(val){
            console.log(val)
            this.hiddenAlert = val;
        },
        toHowItWorks(){
            this.$ga.event('Navbar', 'How It Works Click')
            this.$sendMixpanelEvent('Navbar How It Works Clicked');
        },
        toDashboard(){
            this.$sendMixpanelEvent('Navbar Dashboard Clicked');
            this.$sendMixpanelEvent('Dashboard Sidebar Menu Item Clicked', {
                'Selected Menu Item': 'Dashboard',
                'Selected Submenu Item': 'Crossprom Requests'
            })
            this.$sendMixpanelEvent('Dashboard Received Requests Tab Clicked')


            this.$ga.event('Navbar', 'Dashboard Click')
            this.$ga.event('Dashboard', 'Sidebar Menu Item Click', `
                Item: Dashboard,
                SubItem: Crossprom Requests
            `)
            this.$ga.event('Dashboard', 'Received Requests Tab Click')

        },
        handleSearchIconClick(){
            this.showSearchBar = true
            this.$ga.event('Navbar', 'Search Icon Click')
            this.$sendMixpanelEvent('Navbar Search Icon Clicked');
        },
        hide: function () {
            this.showSearchBar = false
        },
        setAddButtonLink() {
            if(this.isEcommercePlatform) {
                return this.addButtonLink = '/add-shop'
            }
            if(this.$route.fullPath === '/wizard') {
                return this.addButtonLink = '/wizard'
            }
        },
        openWizard: function () {

            if(this.isEcommercePlatform){
                this.$ga.event('Add Shop', 'Page Opened', 'OpenedFrom', 'Navbar');
                this.$sendMixpanelEvent('Add Shop Opened', {
                    'Opened From': 'Navbar'
                });
                return this.$router.push({
                    path: '/add-shop',
                    query
                }).catch(() => {})
            }

            this.$ga.event('Add Wizard', 'Page Opened', 'Location', 'Navbar');
            this.$sendMixpanelEvent('Add Wizard Opened', {
                Location: 'Navbar'
            });
            
            const query = {}
            if (!this.$route.path.startsWith('/wizard')) {
                query.from = this.$route.fullPath
            }
            if(this.$route.fullPath !== '/wizard'){
                this.$router.push({
                    path: '/wizard',
                    query
                }).catch(() => {})
            }
        },
        toMessages: function() {
            chatUseCase.markAllMessagesAsRead()
            this.$sendMixpanelEvent('Chatroom Opened', {
                'Opened From': 'Navbar Icon'
            })
            this.$ga.event('Chat', 'Chatroom Opened', 'OpenedFrom', 'Navbar Icon')
            if(this.$route.path === '/mymessages') return
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables.scss';
.header {
    padding-bottom: 60px;
    &.has-alert {
        padding-bottom: 125px;
    }
}

.fixed-header {
    z-index: 1001;
}

.header-navbar {
    &.no-box-shadow {
        box-shadow: none !important;
    }
    &.inset-shadow {
        box-shadow: inset 0px -1px 0px #E2E8F0;
    }
}
.accept-button {
    span {
        font-family: 'Eina SemiBold';
        font-size: 14px !important;
        line-height: 20px !important;
    }
}
.navbar-item {
   color: #8DA0A9 !important;
   font-size: 14px;
   line-height: 20px;
   font-family: 'Eina SemiBold';
   transition: all 0.2s ease;
   padding: 0 8px;
   margin: 0 12px;

    @media (max-width: 992px) {
        margin: 0;
    }
    &:hover {
        color: #727CF5 !important;
    }
}

.add-campaign-button {
    min-width: 153px;
}

.has-badge {
    display: flex;

    @media screen and (max-width: 1024px) {
        display: none;
    }

    span {
        display: flex;
        position: relative;
        background: #727CF5;
        border-radius: 2px;
        color: #fff;
        display: inline-block;
        padding: 0px 2px;
        width: 23px;
        height: 11px;
        margin-left: 2px;

        &::after {
            content: 'new';
            position: absolute;
            display: inline-block;
            font-size: 9px;
            line-height: 9px;
        }
    }
}
        
    


div.dashboard-header {
    background: #f4f4f4 !important;
    box-shadow: none !important;
    right: 0;
    div[data-name="search-bar"] {
        height: 60px;
        display: flex;
        align-items: center;
        background: white;
    }
    div.cp-navbar {
        display: flex;
        justify-content:flex-end !important;
    }

    .pricingLink {
        padding-right: 15px;
        border-left: none;
    }

    
}
button {
    &.header-icon {
        img {
            transition: all 0.1s ease;

        }
        &:hover {
            img {
                filter: invert(0.2);
            }
        }
    }
}
div.header-icons-wrap {
    border-right: 1px solid #D5D8FC;
    border-left: 1px solid #D5D8FC;
    min-width: 160px;
    justify-content: space-between;

    &.ecommerce {
        min-width: 100px;
        border-left: 0;
        justify-content: flex-end;
    }
}

.add-campaign {
    border-right: 1px solid #D5D8FC;
    button {
        background-color: $c2;
        padding: 5px 15px;
        &:hover {
            margin-top: 0
        }
        span {
            margin-left: 8px;
            font-size: 13px;
            font-weight: bold;
        }
        &.inactive {
            box-shadow: none;
            cursor: default;
        }
    }
}

</style>